import styled from "styled-components";

import ConferenceTable from "../component/conference/ConferenceTable";

const Conference = () => {
  return (
    <StConferenceContainer>
      <ConferenceTable rootCategoryId={483} /> {/* 하드코딩 제거 필요 */}
    </StConferenceContainer>
  )
};

const StConferenceContainer = styled.div`
  padding: 2rem 12rem;
`;

export default Conference;